import * as React from "react";
const SvgPauseFill = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: 24, viewBox: "0 -960 960 960", width: 24, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M560-200v-560h160v560H560Zm-320 0v-560h160v560H240Z" }));
export default SvgPauseFill;
